import {
	createSlice,
	createEntityAdapter,
	createSelector,
} from "@reduxjs/toolkit";

const questionsAdapter = createEntityAdapter();

const initialState = questionsAdapter.getInitialState({
	status: "idle",
	error: null,
});

const questionsSlice = createSlice({
	name: "questions",
	initialState,
	reducers: {
		questionsReceived(state, action) {
			questionsAdapter.setAll(state, action.payload);
		},
	},
});

/*
ACTIONS
Questions data can only ever be received via API
There are no actions to CRUD individual questions
*/
export const { questionsReceived } = questionsSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllQuestions, selectById: selectQuestionById } =
	questionsAdapter.getSelectors((state) => state.questions);

/*
CUSTOM SELECTORS
Table-value questions have a parent/child relationship
*/
export const selectQuestionsByParentQuestionId = createSelector(
	[selectAllQuestions, (state, parentQuestionId) => parentQuestionId],
	(questions, parentQuestionId) =>
		questions.filter((q) => q.parentQuestionId === parentQuestionId)
);

export const selectQuestionsError = (state) => state.questions.error;

export default questionsSlice.reducer;
